import {createStyles, keyframes} from '@mantine/core';
import React from 'react';

const shimmerKeyframes = keyframes({
  '0%': {backgroundPosition: '200% 0'},
  '100%': {backgroundPosition: '-200% 0'},
});

export const fadeInKeyframes = keyframes({
  '0%': {opacity: 0, transform: 'translateY(4px)'},
  '100%': {opacity: 1, transform: 'translateY(0)'},
});

export const spinKeyframes = keyframes({
  '0%': {transform: 'rotate(0deg)'},
  '100%': {transform: 'rotate(360deg)'},
});

export function LoadingShimmerList({count = 2}: {count?: number}): JSX.Element {
  const {classes, cx} = useLoadingStyles();
  return (
    <div className={classes.loadingList}>
      {Array.from({length: count}, (_, i) => (
        <div key={i} className={classes.loadingRow} style={{animationDelay: `${i * 120}ms`}}>
          <div className={classes.loadingIcon} />
          <div className={classes.loadingTextStack}>
            <div className={cx(classes.loadingBar, classes.loadingBarTitle)} />
            <div className={cx(classes.loadingBar, classes.loadingBarSubtitle)} />
          </div>
        </div>
      ))}
    </div>
  );
}

const useLoadingStyles = createStyles((theme) => ({
  loadingList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.xs,
  },
  loadingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    padding: theme.spacing.sm,
    borderRadius: theme.radius.sm,
    height: 48,
    opacity: 0,
    animation: `${fadeInKeyframes} 260ms ease forwards`,
  },
  loadingIcon: {
    width: 24,
    height: 24,
    borderRadius: theme.radius.sm,
    flexShrink: 0,
    background: `linear-gradient(120deg, ${theme.colors.gray[1]} 0%, ${theme.colors.gray[3]} 40%, ${theme.colors.gray[1]} 80%)`,
    backgroundSize: '200% 100%',
    animation: `${shimmerKeyframes} 1.6s linear infinite`,
  },
  loadingTextStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    flex: 1,
  },
  loadingBar: {
    height: 10,
    borderRadius: theme.radius.xs,
    background: `linear-gradient(120deg, ${theme.colors.gray[1]} 0%, ${theme.colors.gray[3]} 40%, ${theme.colors.gray[1]} 80%)`,
    backgroundSize: '200% 100%',
    animation: `${shimmerKeyframes} 1.6s linear infinite`,
  },
  loadingBarTitle: {
    width: '55%',
  },
  loadingBarSubtitle: {
    width: '85%',
  },
}));
